<template>
  <section id="content" class="content hidden md:block pt-12 pb-20">
    <div class="container mx-auto px-4">
      <h2 class="landing-h2 text-center mb-12">
        <template v-for="currentBlok in blok.headline">
          <span :class="[currentBlok.hasColorGradient ? 'gradient-dark' : '']">
            {{ currentBlok.text }}&nbsp;
          </span>
        </template>
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-[1fr_3fr] bg-[url('/coisar-wave-white.svg')] bg-center bg-no-repeat gap-8 bg-slate-100 rounded-3xl">
        <!-- Content-Menu -->
        <nav class="content-menu bg-gradient-to-br from-indigo-900 to-indigo-700 text-white rounded-3xl p-6">
          <ul class="space-y-4 text-center md:text-start">
            <li v-for="(point, index) in blok.tabs" :key="point._uid" @click="activeTab = index" class="cursor-pointer px-6 py-4 rounded-full transition-colors" :class="activeTab === index ? 'bg-indigo-500 text-lg font-extrabold md:-mr-12' : 'hover:bg-indigo-500 hover:bg-opacity-50'">
              <span class="flex justify-between items-center w-full">
                {{ point.title }}
                <font-awesome-icon v-if="activeTab === index" :icon="['fasr', 'chevron-down']" class="ml-4 bg-white text-indigo-900 rounded-full w-6 h-6 flex items-center justify-center p-2 -mr-2 block md:hidden" />
                <font-awesome-icon v-if="activeTab === index" :icon="['fasr', 'chevron-right']" class="ml-4 bg-white text-indigo-900 rounded-full w-6 h-6 flex items-center justify-center p-2 -mr-2 hidden md:block" />
              </span>
            </li>
          </ul>
        </nav>

        <!-- Content-Box -->
        <div class="content-box p-8 pb-0">
          <template v-if="blok.tabs[activeTab]">
            <h3 class="text-2xl font-semibold mb-4">
              {{ blok.tabs[activeTab].title }}
            </h3>
            <p class="mb-6 text-gray-800 md:w-[75%]">
              {{ blok.tabs[activeTab].textarea }}
            </p>
            <img
              :src="blok.tabs[activeTab].image?.filename"
              :alt="blok.tabs[activeTab].image?.alt"
              class="content-image -mb-16"
            />
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

/**
 * 'blok' kommt von Storyblok und hat in diesem Fall mindestens:
 * blok.tabs = [
 *   { _uid: 'abc123', title: 'ENERGIETYP', textarea: '…', image: '/pfad-evtl.png' },
 *   { _uid: 'def456', title: 'PROFIL',      textarea: '…', image: '/pfad-evtl.png' },
 *   // … insgesamt 11 Items …
 * ]
 */
defineProps({ blok: Object })

// Index des aktuell ausgewählten Tabs (Start: erstes Element = 0)
const activeTab = ref(0)

// === HIER NEU: Statische Bildpfade für die 11 Tabs ===
const imagePaths = [
  '/content-image.png',
  '/content-image.png',
  '/content-image.png',
  '/content-image.png',
  '/content-image.png',
  '/content-image.png',
  '/content-image.png',
  '/content-image.png',
  '/content-image.png',
  '/content-image.png',
  '/content-image.png'
]
</script>

<style scoped>
/* Falls du noch spezifische Anpassungen brauchst, kannst du sie hier ergänzen. */

/* Beispiel: Der Linke Reiter bekommt bei aktivem Zustand dunklere Schrift: */
.content-menu li {
  font-weight: 500;
}
/* ...und beim aktiven Tab: */
.content-menu li.bg-indigo-300 {
  font-weight: 700;
}
</style>
<!--
<template>
    <section class="content items-center pt-24 pb-12">
        <div class="container flex flex-col justify-between items-center gap-8">
            <h2 class="landing-h2">
                <template v-for="currentBlok in blok.headline">
                    <span :class="[currentBlok.hasColorGradient ? 'gradient-dark' : '']">{{ currentBlok.text }}&nbsp;</span> 
                </template>
            </h2>
            <div v-for="point in blok.tabs" class="grid grid-cols-2">
                <div class="content-menu">
                    <h3>{{ point.title }}</h3>
                </div>
                <div class="content-box">
                    <p>{{ point.textarea }}</p>
                    <img class="content-image" alt="Content Image" src="/content-image.png">
                </div>
            </div>
        </div>
     </section>
</template>

<script setup>
    defineProps({ blok: Object })
</script>
 -->